import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as IconLink } from '../../media/icons/arrow_right.svg';


export default class Destinationcarousel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            destination_data: [
                {
                    label: "Australia",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/australia.webp"
                },
                {
                    label: "Austria",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/austria.webp"
                },
                {
                    label: "China",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/china.webp"
                },
                {
                    label: "Finnland",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/finnland.webp"
                },
                {
                    label: "Germany",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/germany.webp"
                },
                {
                    label: "Greece",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/greece.webp"
                },
                {
                    label: "Netherlands",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/netherlands.webp"
                },
                {
                    label: "Portugal",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/portugal.webp"
                },
                {
                    label: "Switzerland",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/switzerland.webp"
                },
                {
                    label: "Tanzania",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/tanzania.webp"
                },
                {
                    label: "United Kingdom",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/united+kingdom.webp"
                },
                {
                    label: "Spain",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/spain.webp"
                },
                {
                    label: "Italy",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/italy.webp"
                },
                {
                    label: "France",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/france.webp"
                },
                {
                    label: "Colombia",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/colombia.webp"
                },
                {
                    label: "Costa Rica",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/costa+rica.webp"
                },
                {
                    label: "Iceland",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/iceland.webp"
                },
                {
                    label: "Japan",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/japan.webp"
                },
                {
                    label: "Mexico",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/mexico.webp"
                },
                {
                    label: "Morocco",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/morocco.webp"
                },
                {
                    label: "South Africa",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/south+africa.webp"
                },
                {
                    label: "Thailand",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/thailand.webp"
                },
                {
                    label: "Turkey",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/turkey.webp"
                },
                {
                    label: "Vietnam",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/vietnam.webp"
                },
                {
                    label: "United Arab Emirates",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/united+arab+emirates.webp"
                },
                {
                    label: "United States",
                    picture: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/destinations/united+states.webp"
                }
            ],
            destination_list_sorted: [],
            expanded: false
        };

        this.toggleAll = this.toggleAll.bind(this);
    }


    componentDidMount() {
        var destination_list_sorted = this.state.destination_data.sort(() => Math.random() - 0.5);
        this.setState({
            destination_list_sorted: destination_list_sorted
        });
    }


    toggleAll() {
        var state = this.state.expanded;
        this.setState({
            expanded: !state
        });
    }


    render() {

        return (
            <div className="home__carousel-container">
                <h2 className="home__carousel__title text-title">
                    {this.props.label}
                </h2>
                <div className={"home__carousel-wrapper"}>

                    {this.state.destination_list_sorted.map((destination, index) => (
                        <Link key={index} to={"/trips?country=" + destination.label + "&sort=views"} className={"home__carousel__element" + (this.state.expanded ? " home__carousel__element--expanded" : "")}>
                            <div className="destinationcarousel__element__picture">
                                <div className="destinationcarousel__element__picture-overlay"></div>
                                <img src={destination.picture} alt={destination.label} className={"destinationcarousel__element__picture-inner"} />
                                <div className="destinationcarousel__element__title text-subtitle text-bold">
                                    {destination.label}
                                </div>
                            </div>
                        </Link>
                    ))}

                    <div onClick={this.toggleAll} className="home__tripcarousel__link-container">
                        {this.state.expanded &&
                            <div className="home__tripcarousel__link__label">
                                See less
                            </div>
                        }
                        {!this.state.expanded &&
                            <div className="home__tripcarousel__link__label">
                                See more
                            </div>
                        }
                        <IconLink className="home__tripcarousel__link__icon" />
                    </div>

                </div>

            </div>
        )
    }
}
